import { render, staticRenderFns } from "./WeightDistributeConfig.vue?vue&type=template&id=13c52339&scoped=true&"
import script from "./WeightDistributeConfig.vue?vue&type=script&lang=js&"
export * from "./WeightDistributeConfig.vue?vue&type=script&lang=js&"
import style0 from "./WeightDistributeConfig.vue?vue&type=style&index=0&id=13c52339&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c52339",
  null
  
)

export default component.exports